import { routes as avisosnotificacoes } from './avisosnotificacoes';
import { routes as bloqueiolancamento } from './bloqueiolancamento';
import { routes as ensinoescola } from './ensinoescola';
import { routes as copiaanoanterior } from './copiaanoanterior';
import { routes as escola } from './escola';
import { routes as pessoas } from './pessoas';
import { routes as configuracaoenvios } from './configuracaoenvios';
import { routes as mensagensrede } from './mensagensrede';
import { routes as unificacaocadastro } from './unificacaocadastro';
import { routes as manutencaoalocacoes } from './manutencaoalocacoes';

export default [
  {
    path: '/administracao',
    name: 'Administracao',
    description: 'Módulo Administração',
    children: [
      ...escola,
      ...pessoas,
      ...avisosnotificacoes,
      ...ensinoescola,
      ...copiaanoanterior,
      ...bloqueiolancamento,
      ...configuracaoenvios,
      ...mensagensrede,
      ...unificacaocadastro,
      ...manutencaoalocacoes,
    ],
    goesToMenu: true,
  },
];
